var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useCallback, useMemo } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import queryString from 'query-string';
var options = { parseBooleans: true };
export var useQuery = function () {
    var location = useLocation();
    var history = useHistory();
    var pathname = useMemo(function () {
        var windowPathname = window.location.pathname;
        // если манипуляции с урлом происходят не через react-router то приоритетнее window.location.pathname
        // (в location из реакт-роутера останется старый необновленный location)
        if (location.pathname !== windowPathname)
            return windowPathname;
        return location.pathname;
    }, [location.pathname]);
    var query = useMemo(function () { return queryString.parse(location.search, options); }, [location.search]);
    var pushQuery = useCallback(function (queryObj) {
        var modifiedQuery = __assign(__assign({}, query), queryObj);
        history.push({
            pathname: pathname,
            search: queryString.stringify(modifiedQuery),
        });
    }, [history, pathname, query]);
    var replaceQuery = useCallback(function (queryObj, options) {
        var modifiedQuery = __assign(__assign({}, query), queryObj);
        history.replace({
            pathname: pathname,
            search: queryString.stringify(modifiedQuery, options),
        });
    }, [history, pathname, query]);
    return { query: query, pushQuery: pushQuery, replaceQuery: replaceQuery, pathname: pathname };
};
//# sourceMappingURL=useQuery.js.map